import React from "react";
import { connect } from "react-redux";
import PanelLoadingIndicator from "components/PanelLoadingIndicator";
import AddModulesDrawer from "browse-media/components/AddModulesDrawer";
import BrowseMediaSearch from "browse-media/components/BrowseMediaSearch";
import BrowseMediaFacetDialog from "browse-media/components/BrowseMediaFacetDialog";
import EditMedia from "edit-media/components/EditMedia";
import RemoveModulesConfirmationDialog from "browse-media/components/RemoveModulesConfirmationDialog";
import RemoveModulesDrawer from "browse-media/components/RemoveModulesDrawer";
import { getEditMediaVisible } from "common/selectors";
import styles from "browse-media/components/BrowseMedia.css";
import PanelHeader from "manager-panel/PanelHeader";

const BrowseMedia = ({ mediaLoaded, editMediaVisible }) => (
  <div className={styles.panel}>
    <PanelHeader label="Browse Media" icon="library_books" />
    {editMediaVisible ? (
      <div className={styles.panelBody}>
        <EditMedia />
      </div>
    ) : (
      <div className={styles.panelBody}>
        {mediaLoaded ? <BrowseMediaSearch /> : <PanelLoadingIndicator />}

        <AddModulesDrawer />
        <RemoveModulesDrawer />
        <RemoveModulesConfirmationDialog />
        <BrowseMediaFacetDialog />
      </div>
    )}
  </div>
);

const mapStateToProps = state => {
  const { mediaLoaded } = state.browseMedia;
  const editMediaVisible = getEditMediaVisible(state);

  console.log(state.browseMedia);

  return {
    mediaLoaded,
    editMediaVisible,
  };
};

export default connect(mapStateToProps)(BrowseMedia);
